export default function SearchResults() {
  return (
    <div>
      <h1>Search Results</h1>
    </div>
  );
}
